import React, { useState } from 'react';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import TextField from 'src/components/text-field';
import Button from 'src/components/button';
import AuthLayout from 'src/containers/auth-layout';
import { useLocation, useNavigate } from 'react-router-dom';
import Service from 'src/setup/network';
import { PasswordTextField } from 'src/components';

interface IProps {}

const FORM_VALIDATION = Yup.object().shape({
  newPassword: Yup.string()
    .matches(
      /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,20}$/,
      'Password must be atleast one alpha numeric character,8 character long,at least one numeric and upto.'
    )
    .required('Required'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('newPassword'), null], 'Password must match')
    .required('Required'),
});

const ResetPassword: React.FC<IProps> = () => {
  const [errorMsg, setErrorMsg] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  const initVal = {
    newPassword: '',
    confirmPassword: '',
  };

  // Check if location.state has required values, if not, redirect to forgot_password
  React.useEffect(() => {
    if (!location.state || !location.state.email || !location.state.otp) {
      navigate('../forgot_password');
    }
  }, [location, navigate]);

  const handleResetPassword = async (val: any) => {
    const payload = {
      ...val,
      email: location.state.email,
      otp: location.state.otp,
      // otp:otp.toString(),
      // email:email
    };
    try {
      await Service.post('/employees/resetPassword', payload);
      navigate('/login');
    } catch (err: any) {
      setErrorMsg(err?.response?.data?.messsage);
    }
  };
  return (
    <div className="min-h-screen">
      <div className="col-span-12 sm:col-span-6 md:col-span-6 lg:col-span-4">
        <div className="mt-[170px]">
          <h1 className="text-4xl font-semibold mb-5">Reset Password</h1>

          <Formik
            initialValues={initVal}
            onSubmit={handleResetPassword}
            validateOnMount
            validationSchema={FORM_VALIDATION}
          >
            {({ isSubmitting, isValid }) => (
              <Form>
                {errorMsg && (
                  <p className="text-center text-warning font-semibold">
                    {errorMsg}
                  </p>
                )}

                <PasswordTextField label="New Password" name="newPassword" />
                <PasswordTextField
                  label="Confirm Password"
                  name="confirmPassword"
                />
                <Button
                  text="Reset Password"
                  variant="primary"
                  type="submit"
                  className="w-full mt-5"
                  isSubmitting={isSubmitting}
                  isValid={isValid}
                />
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
